import * as THREE from "three";
import { eclToScene, rotationState, type BodyId } from "@solar/ephemeris";

/** 各天体的当前显示状态，由 <Body> 每帧写入，由标签层与相机读取。 */
export interface BodyLive {
  /** 绝对显示坐标（float64，模式插值后）。相对原点的位置 = world − frame.origin。 */
  world: THREE.Vector3;
  north: THREE.Vector3;
  /** 当前显示半径（场景单位，已按模式插值）。 */
  radius: number;
  visible: boolean;
}
export const bodyLive = new Map<BodyId, BodyLive>();

const ZERO_ROT = { north: { x: 0, y: 0, z: 1 }, primeMeridian: { x: 1, y: 0, z: 0 }, spinDeg: 0 };

/**
 * 天体朝向：本地坐标 +Y = 北极，+X = 本初子午线（经度 0°），东 = −Z（与 three SphereGeometry 的 UV 一致）。
 * `visualSpinOffsetDeg` 用于高速播放时限制视觉转速（真实相位 + 偏移）。
 */
export function bodyQuaternion(id: BodyId, date: Date, visualSpinOffsetDeg = 0): { q: THREE.Quaternion; north: THREE.Vector3; trueSpinDeg: number } {
  const r = rotationState(id, date) ?? ZERO_ROT;
  const n = new THREE.Vector3(...eclToScene(r.north)).normalize();
  const pm = new THREE.Vector3(...eclToScene(r.primeMeridian)).normalize();
  const z = new THREE.Vector3().crossVectors(pm, n);
  const q = new THREE.Quaternion().setFromRotationMatrix(new THREE.Matrix4().makeBasis(pm, n, z));
  if (visualSpinOffsetDeg) q.premultiply(new THREE.Quaternion().setFromAxisAngle(n, (visualSpinOffsetDeg * Math.PI) / 180));
  return { q, north: n, trueSpinDeg: r.spinDeg };
}
